import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import ContentArea from 'components/common/ContentArea';

import { ToggleProps } from './interfaces';

import useStyles from './style';

const Toggle: FC<PropsWithChildren<ToggleProps>> = ({ toggleClassName, children, ...rest }) => {
  const classes = useStyles();

  return (
    <ContentArea
      {...rest}
      className={classNames('viboToggleDropdown', classes.viboToggleDropdown, toggleClassName)}
    >
      {children}
    </ContentArea>
  );
};

export default Toggle;
